<template>
	<div class="page">
		<Tip :title="title" />
		<div class="from_div">
			<el-form label-position="left" label-width="100px">
				<el-form-item label="结算方：" style="margin-bottom: 0px;">
					<div class="row">
						<span class="span">{{detail.supplier_company}}</span>
						<span class="span" style="margin-left: 100px;">结算单号：{{detail.settlement_no}}</span>
					</div>
				</el-form-item>
				<el-table class="table_div" :data="detail.sku_list" :header-cell-style="tabStyle">
					<el-table-column label="编号" type="index" width="80">
					</el-table-column>
					<el-table-column label="商品">
						<template slot-scope="scope">
							<div class="col">
								<span>名称：{{scope.row.good_name}}</span>
								<span>规格：{{scope.row.spec_data_str}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="未结算量">
						<template slot-scope="scope">
							<span>{{scope.row.settlement_undo}}</span>
						</template>
					</el-table-column>
					<el-table-column label="本次结算">
						<template slot-scope="scope">
							<span>{{scope.row.quatity}}</span>
						</template>
					</el-table-column>
					<el-table-column label="单价">
						<template slot-scope="scope">
							<span>{{scope.row.price}}</span>
						</template>
					</el-table-column>
					<el-table-column label="金额">
						<template slot-scope="scope">
							<span>{{scope.row.amount}}</span>
						</template>
					</el-table-column>
				</el-table>
				<el-form-item label="合计金额：" style="margin-bottom: 0px;">
					<div class="row">
						<span class="span">{{detail.settlement_amount}}元</span>
						<span class="span" style="margin-left: 100px;">修改结算金额为：{{detail.settlement_amount}}元</span>
					</div>
				</el-form-item>
				<el-form-item label="收款信息：" style="margin-bottom: 0px;">
					<div class="col">
						<span class="span">银行卡号：{{detail.collection_card}}</span>
						<span class="span">账户名称：{{detail.collection_name}}</span>
						<span class="span">开户银行：{{detail.collection_bank}}</span>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close(0)">返回</el-button>
			<!-- <el-button type="warning" @click="close(1)">制付款单</el-button> -->
			<el-button type="primary" @click="pay">确认付款</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import {supplier} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		props:{
			type:{
				type:Number
			}
		},
		data() {
			return {
				title: '批量结算',
				detail: {},
                form: {
                    sku_ids: '',
                },
                amount_calc: 0,
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
			this.supplierDetail();
		},
		methods: {
			//获取结算单详情
			supplierDetail(){
				supplier({settlement_id:this.type},1).then(res=>{
					if(res.code == 0){
						this.detail = res.data
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err=>{})
			},
			pay(){
                supplier({settlement_id:this.type}, 6).then(res=>{
					if(res.code == 0){
                        this.$message.success(res.msg || '操作成功');
						this.$emit('close', 1)
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err=>{})
            }
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}
	
	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 570px;
		min-height: 100%;
		padding-bottom: 66px;
	}
	
	.table_div {
		width: 100%;
		margin: 10px 0;
	}
	

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>